import {css, html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {of} from 'rxjs';
import {FilterView} from './filter-view';
import global_css from './global-css';
import {Panel} from './panel';
import {ri} from './runner-idle';
import {any$} from './utils';

@customElement('ri-stats')
export class Stats extends FilterView {
  // #region Properties (2)

  public override id = 'stats';
  public override name = 'Stats';
  public override isIntersection = true;

  static override styles = [...FilterView.styles, css``];

  // #endregion Properties (3)

  // #region Public Methods (1)
  constructor() {
    super();
    this.unlock$ = any$(Object.values(ri.stats).map((stat) => stat.unlock$));
    this.filterables$ = of(Object.values(ri.stats));
  }

  //   public override render() {
  //     return super.render(html`<div id="stats-container" class="container">
  //       ${Object.values(ri.stats).filter((s) => s.unlocked)}
  //     </div>`);
  //   }

  // #endregion Public Methods (1)
}
